export interface GetAuditTrailLogRequestModel {
  dateFrom?: string
  dateTo?: string
  clientName?: string
  accountNumber?: string
  userIds?: string[]
  tableNames?: string[]
  actions?: string[]
  databaseName?: string
  pageIndex?: number
  pageSize?: number
  sortColumns?: string[]
  isDesc?: boolean
  searchTerm?: string
  searchColumns?: string[]
  filterOption: FilterOptionEnum
  export?: ExportRequestModel
}

export enum FilterOptionEnum {
  List = 0,
  Excel = 1,
  Pdf = 2,
}

export interface ExportRequestModel {
  chosenColumnNameList: Record<string, string>
  pageName: string
  header?: string
}

export interface AuditUserResponseModel {
  userId: string
  userName: string
}